export default "__VITE_ASSET__zSCozSYk__"